export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/fission/capsule-station' */ './CapsuleStation'
  );
